import { createSlice } from "@reduxjs/toolkit";
import {GroupsListing,Pagination} from "../../../types/create-test/group-listing/groupsListingSchema";

const initialState = {
    items: [] as GroupsListing[],
    pagination: {} as Pagination,
    isLoading: true,
    error: null,
};

const groupsListingSlice = createSlice({
    name: "groupsListing",
    initialState,
    reducers: {
        setGroupsListing: (state, action) => {
            const { items, pagination } = action.payload;
            state.items = items;
            state.pagination = pagination;
            state.isLoading = false;
            state.error = null;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setGroupsListing, setLoading, setError } = groupsListingSlice.actions;


export const groupsListingReducer = groupsListingSlice.reducer;

